module.exports = __webpack_public_path__ + "img/National-Museum-of-History.639131c0.jpg";